import { QuizFeedback } from '@/pages/pii-training/QuizFeedback';
import type { QuizQuestionFieldProps } from '@/pages/pii-training/piiTraining.types';
import type { QuizAnswer } from '@/types/piiTraining';
import { ChoiceCard, ChoiceCardGroup, Grid, Stack, Text } from '@careflux/primitives';
import { Controller } from 'react-hook-form';

const ANSWERS: QuizAnswer[] = ['yes', 'no'];

const isQuizAnswer = (value: string): value is QuizAnswer => value === 'yes' || value === 'no';

export const QuizQuestionField = ({ question, index, copy, control }: QuizQuestionFieldProps) => (
  <Controller
    name={question.id}
    control={control}
    render={({ field }) => {
      const labelId = `${question.id}-label`;

      return (
        <Stack gap="sm">
          <Text id={labelId} size="sm" weight="medium">
            {copy.exampleLabel(index + 1)}
          </Text>
          <Text asChild>
            <p>{question.scenario}</p>
          </Text>
          <Grid asChild columns={2} gap="sm">
            <ChoiceCardGroup
              aria-labelledby={labelId}
              size="sm"
              indicator="radio"
              value={field.value ?? ''}
              onValueChange={(value) => {
                if (isQuizAnswer(value)) field.onChange(value);
              }}
            >
              {ANSWERS.map((answer) => (
                <ChoiceCard
                  key={answer}
                  value={answer}
                  label={
                    <Text size="sm" weight="medium" transform="capitalize">
                      {copy[answer]}
                    </Text>
                  }
                />
              ))}
            </ChoiceCardGroup>
          </Grid>
          {field.value && (
            <QuizFeedback
              correct={field.value === question.correctAnswer}
              message={field.value === question.correctAnswer ? question.feedbackCorrect : question.feedbackIncorrect}
            />
          )}
        </Stack>
      );
    }}
  />
);
